import React from "react";

/**
 * Oversized display pull quote with optional red emphasis word.
 * Use {{word}} in `children` to mark the word that should be styled red.
 */
export const PullQuote = ({ children, className = "" }) => {
  const parts =
    typeof children === "string"
      ? children.split(/(\{\{[^}]+\}\})/g).filter(Boolean)
      : [children];

  return (
    <blockquote
      data-testid="pull-quote"
      className={`font-display uppercase tracking-tight leading-[0.95] text-4xl sm:text-6xl md:text-7xl lg:text-8xl ${className}`}
    >
      {parts.map((p, i) => {
        if (typeof p === "string" && /^\{\{.*\}\}$/.test(p)) {
          return (
            <span key={i} className="text-red">
              {p.slice(2, -2)}
            </span>
          );
        }
        return <span key={i}>{p}</span>;
      })}
    </blockquote>
  );
};

export default PullQuote;
